import { autoMount } from '../../../utils/autoMount';
import { FeaturedSlider } from '../../../components/organisms/featuredSlider';

autoMount({ FeaturedSlider });
